import { signInWithEmailAndPassword } from "firebase/auth";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import { auth } from "../firebase-key";

const Login = () => {
    const [loading, setLoading] = useState(false)
    const [showPass, setShowPass] = useState(false)

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm()

    const onSubmit = async (data) => {
        setLoading(true)
        try {
            await signInWithEmailAndPassword(auth, data.email, data.password)
            toast.success("Logged in successfully! 🚀")
            window.location.href = "/"
        }
        catch (err) {
            const msg = err?.message || "Login failed"

            if (msg.includes("invalid-email")) toast.error("Invalid Email")
            else if (msg.includes("user-not-found")) toast.error("User does not exist")
            else if (msg.includes("wrong-password")) toast.error("Incorrect password")
            else toast.error("Something went wrong, try again!")
        }
        finally {
            setLoading(false)
        }
    }

    return (
        <div className="min-h-screen flex justify-center items-center bg-[#f7f9fc] px-4">
            <ToastContainer />
            <div className="w-full max-w-md bg-white p-10 rounded-2xl shadow-lg border border-gray-200">

                <h1 className="text-3xl font-semibold text-center text-gray-800 mb-6">
                    Welcome Back 👋
                </h1>

                <p className="text-center text-gray-500 mb-8">
                    Sign in to continue to your dashboard
                </p>

                <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">

                    {/* Email */}
                    <div>
                        <label className="text-sm text-gray-700">Email</label>
                        <input
                            type="email"
                            className="w-full mt-1 px-4 py-3 rounded-lg bg-gray-50 text-gray-800 
                         border border-gray-300 focus:ring-2 focus:ring-blue-400 outline-none"
                            placeholder="you@email.com"
                            {...register("email", { required: "Email is required" })}
                        />
                        {errors.email && (
                            <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
                        )}
                    </div>

                    {/* Password */}
                    <div>
                        <label className="text-sm text-gray-700">Password</label>

                        <div className="relative">
                            <input
                                type={showPass ? "text" : "password"}
                                className="w-full mt-1 px-4 py-3 rounded-lg bg-gray-50 text-gray-800 
                           border border-gray-300 focus:ring-2 focus:ring-blue-400 outline-none"
                                placeholder="••••••••"
                                {...register("password", { required: "Password is required" })}
                            />

                            <span
                                onClick={() => setShowPass(!showPass)}
                                className="absolute right-3 top-4 cursor-pointer text-gray-500"
                            >
                                {showPass ? "🙈" : "👁️"}
                            </span>
                        </div>

                        {errors.password && (
                            <p className="text-red-500 text-sm mt-1">{errors.password.message}</p>
                        )}
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        disabled={loading}
                        className={`w-full py-3 rounded-lg text-white font-semibold transition 
                       ${loading ? "bg-blue-300 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"} `}
                    >
                        {loading ? "Signing in..." : "Login"}
                    </button>
                </form>

                {/* Signup Link */}
                <p className="text-gray-600 text-center mt-6">
                    Don’t have an account?{" "}
                    <a href="/signup" className="text-blue-600 font-medium hover:underline">
                        Create one
                    </a>
                </p>
            </div>
        </div>
    )
}

export default Login
